import { render, staticRenderFns } from "./EmptyApprovals.vue?vue&type=template&id=0e2b986e&scoped=true"
import script from "./EmptyApprovals.vue?vue&type=script&lang=js"
export * from "./EmptyApprovals.vue?vue&type=script&lang=js"
import style0 from "./EmptyApprovals.vue?vue&type=style&index=0&id=0e2b986e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2b986e",
  null
  
)

export default component.exports